import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import PracticeMentorModal from "./PracticeMentorModal";
import PracticeMentorTable from "./PracticeMentorTable";
import MentorUploadModal from "./MentorUploadModal";
import { getAllMentors } from '../../../services/adminServices/AdminServices';
import { getAllCOE } from '../../../services/adminServices/CoeServices';
import { toast } from "react-toastify";

const PracticeMentor = () => {
    const [openModal, setOpenModal] = useState({ userForm: false, uploadForm: false });
    const [rowData, setRowData] = useState([]);
    const [allCOE, setCOE] = useState([]);
    const [editRowData, setEditRowData] = useState(null);
    const [userName, setUserName] = useState("");
    const [loading, setLoading] = useState(true);

    const handleModalToggle = (modalName, data = null) => {
        setOpenModal((prev) => ({ ...prev, [modalName]: !prev[modalName] }));
        if (!data) {
            setEditRowData(null); 
        } else {
            setEditRowData(data); 
        }
    };

    const getAllUsersData = async () => {
        try {
            setLoading(true);
            const allCOE = await getAllCOE();
            setCOE(allCOE.data.data);
            const response = await getAllMentors();
            setRowData(response?.data?.data || []);
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message || error?.error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        setUserName(user?.name);
        getAllUsersData();
    }, []);

    const handleEditClick = (data) => {
        handleModalToggle('userForm', data);
    };

    return (
        <Box className="dashboard-container">
            <Box className="dashboard-header">
                <Typography className="dashboard-header-title">Welcome {userName}</Typography>
                <Box sx={{ display: "flex", gap: 1.5 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleModalToggle('uploadForm')}
                        className="dashboard-header-button"
                    >
                        UPLOAD Practice Mentor
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleModalToggle('userForm')}
                        className="dashboard-header-button"
                    >
                        CREATE Practice Mentor
                    </Button>
                </Box>
            </Box>
            <PracticeMentorModal
                open={openModal.userForm}
                onClose={() => handleModalToggle('userForm')}
                title={editRowData ? "Edit Mentor" : " Mentor"}
                rowData={editRowData}
                allCOE={allCOE}
                getAllUsersData={getAllUsersData}
            />
            <MentorUploadModal
                open={openModal.uploadForm}
                handleClose={() => handleModalToggle('uploadForm')}
                allCOE={allCOE}
                fetchData={getAllUsersData}
            />
            <Box className="dashboard-box-container">
                <PracticeMentorTable
                    allCOE={allCOE}
                    rows={rowData}
                    loading={loading}
                    onEditClick={handleEditClick}
                    getAllUsersData={getAllUsersData}
                />
            </Box>
        </Box>
    );
};

export default PracticeMentor;

